export const colors = {
  neutral: {
    white: '#ffffff',
    offWhite: '#f9f9f9',
    lighten60: '#f3f4f4',
    lighten40: '#ecedee',
    lighten20: '#e8e8e8',
    base: '#e1e1e1',
    darken20: '#bdbdbd',
    darken40: '#8f9697',
    darken60: '#606e71',
  },
  blue: {
    lighten100: '#F6F8FC',
    lighten80: '#e4e7ed',
    lighten60: '#ccd2de',
    lighten40: '#99a6be',
    lighten20: '#66799d',
    base: '#00205c',
    darken20: '#001a4a',
    darken40: '#001337',
    darken60: '#000d25',
  },
  green: {
    lighten60: '#ccf7dd',
    lighten40: '#99f0ba',
    lighten20: '#66e898',
    base: '#00d953',
    darken20: '#00ce4f',
    darken40: '#00c34b',
    darken60: '#00b847',
  },
  purple: {
    lighten60: '#ecd4f0',
    lighten40: '#d8a9e1',
    lighten20: '#c57ed3',
    base: '#9e28b5',
    darken20: '#7e2091',
    darken40: '#5f186d',
    darken60: '#3f1048',
  },
  red: {
    lighten60: '#f9cfd1',
    lighten40: '#efadb1',
    lighten20: '#e2747a',
    base: '#c22b32',
    darken20: '#91191f',
    darken40: '#79080d',
    darken60: '#670005',
  },
  orange: {
    lighten60: '#f9e6b6',
    lighten40: '#f5d990',
    lighten20: '#f3cd6c',
    base: '#ecad0c',
    darken20: '#d89c02',
    darken40: '#a47105',
    darken60: '#6c4100',
  },
} as const;
